export const volumes = [
  {
    number: "I",
    title: "Early Orthodontic Assessment Blueprint",
    subtitle: "Build a Stronger Foundation Before Considering Treatment",
    intro: [
      "Every early orthodontic decision begins with an appropriate assessment.",
      "This volume helps you organize the clinical information that may be relevant when evaluating growing patients.",
    ],
    items: [
      "Patient history and relevant developmental information.",
      "Extraoral and intraoral examination considerations.",
      "Dental eruption and occlusal development.",
      "Functional observations and clinical findings.",
      "Recognition of findings requiring further investigation.",
      "Documentation and referral considerations.",
      "Structured early assessment worksheets.",
    ],
    objective:
      "Understand how to organize an initial assessment before moving toward treatment decisions.",
  },
  {
    number: "II",
    title: "Mixed Dentition & Growth Assessment Atlas",
    subtitle: "Understand the Developmental Context Behind the Clinical Findings",
    intro: [
      "A growing patient's dentition is constantly changing.",
      "Understanding these changes is essential when evaluating orthodontic problems during childhood.",
    ],
    items: [
      "Primary, mixed, and permanent dentition development.",
      "Eruption patterns and developmental variation.",
      "Space relationships and arch development.",
      "Skeletal growth considerations.",
      "Dental and skeletal discrepancies.",
      "Growth assessment limitations.",
      "Visual developmental reference charts.",
    ],
    objective:
      "Learn to interpret orthodontic findings within the context of dental development and growth.",
  },
  {
    number: "III",
    title: "Early Malocclusion Decision Pathway",
    subtitle: "Recognize Developing Problems and Organize Your Clinical Reasoning",
    intro: [
      "Not all malocclusions follow the same developmental course.",
      "This volume introduces structured educational decision pathways for reviewing common early orthodontic presentations.",
    ],
    items: [
      "Anterior and posterior crossbite assessment.",
      "Developing Class II and Class III relationships.",
      "Open bite and deep bite considerations.",
      "Dental crowding and spacing.",
      "Eruption disturbances.",
      "Functional shifts and occlusal relationships.",
      "Criteria for observation, additional evaluation, intervention consideration, and referral.",
    ],
    objective:
      "Move from identifying a malocclusion to understanding the factors that influence its clinical evaluation.",
  },
  {
    number: "IV",
    title: "Interceptive Treatment Planning Blueprint",
    subtitle: "Organize Phase I Treatment Objectives Before Selecting an Approach",
    intro: [
      "Recognizing a problem does not automatically establish the need for treatment.",
      "A thoughtful plan requires clear objectives, appropriate indications, consideration of alternatives, and awareness of limitations.",
    ],
    items: [
      "Defining early orthodontic treatment objectives.",
      "Evaluating treatment indications.",
      "Considering observation versus intervention.",
      "Understanding the limitations of Phase I treatment.",
      "Principles of treatment timing.",
      "Appliance-selection considerations.",
      "Referral and interdisciplinary planning.",
      "Structured treatment-planning worksheets.",
    ],
    objective:
      "Develop a more organized approach to evaluating potential interceptive treatment plans.",
  },
  {
    number: "V",
    title: "Phase I Treatment Monitoring Roadmap",
    subtitle: "Understand What to Review as a Growing Patient Develops",
    intro: [
      "Early orthodontic assessment doesn't end with the initial treatment decision.",
      "Growth, eruption, treatment response, and changing clinical findings require periodic reassessment.",
    ],
    items: [
      "Monitoring dental development.",
      "Reviewing treatment objectives.",
      "Recognizing changes that warrant reassessment.",
      "Documenting treatment progress.",
      "Evaluating limitations and unexpected findings.",
      "Understanding transition considerations between treatment phases.",
      "Follow-up documentation templates.",
    ],
    objective:
      "Build a systematic educational framework for monitoring and reviewing developing orthodontic cases.",
  },
  {
    number: "VI",
    title: "Interceptive Orthodontic Clinical Case Atlas",
    subtitle: "Connect the Concepts Through Visual Case-Based Learning",
    intro: [
      "This is where the previous volumes come together.",
      "Instead of studying individual concepts in isolation, you'll explore how clinical findings can be organized into coherent educational case assessments.",
    ],
    items: [
      "Mixed dentition assessment examples.",
      "Developing malocclusion scenarios.",
      "Growth-related planning considerations.",
      "Clinical decision pathway exercises.",
      "Observation versus intervention discussions.",
      "Phase I planning examples.",
      "Follow-up and reassessment scenarios.",
      "One-page case organization templates.",
    ],
    objective:
      "Practice connecting clinical observations, developmental considerations, and treatment-planning principles.",
  },
];

export const learningResources = [
  {
    title: "Early Assessment Checklists",
    text: "Structured lists for reviewing relevant findings during early orthodontic assessment.",
  },
  {
    title: "Clinical Decision Pathways",
    text: "Visual educational algorithms for comparing different assessment and planning considerations.",
  },
  {
    title: "Growth & Dentition Reference Charts",
    text: "Illustrated references covering dental development and growth-related concepts.",
  },
  {
    title: "Phase I Planning Worksheets",
    text: "Reusable templates for organizing findings, objectives, limitations, and follow-up considerations.",
  },
];

export const caseMatrixSteps = [
  "Finding",
  "Interpretation",
  "Developmental Context",
  "Clinical Considerations",
  "Next Assessment Step",
];
